<template>
  <div class="content" id="content_404">
    <div class="bg">
      <img src="./../assets/img/404-bg.png" />
      <h2>{{$t("title_404")}}</h2>
      <p>{{$t("text_line_1_404")}}<br />{{$t("text_line_2_404")}}</p>
      <router-link :to="'/'" class="back_button">{{$t("button_404")}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$bus.$emit('ChangeHeadings', "404 Page not Found", null)
  },
}
</script>

<style lang="scss">
@import './../assets/css/variables';

.bg{
  height: 100%;
  width: 100%;
  text-align: center;
  img{
    width: 580px;
    @media screen and (max-width: $mobile) {
      width: 100%;
      height: auto;
    }
  }
}

#content_404{
  background-color: #10182a;
  margin-top: -1px !important;
  h2{
    font-family: "Roboto", Sans-serif;
    font-size: 22px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: -0.44px;
    color:#e04ef8;
    border: 0;
    margin-bottom: 20px;
    display: block !important;
  }
  p{
    font-family: "Roboto", Sans-serif;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0px;
    color: #fff;
    line-height: 26px;
    margin-bottom: 20px;
  }
}

main[section_name='404']{
  @media screen and (max-width: $mobile) {
      padding: 0;
  }
  #content{
    background-color:transparent;
    padding: 0 !important;
    padding-bottom: 100px !important;
    width: 100%;
    float: none;
    h2{
      display: none;
    }
  }
  .sidenav{
    display: none;
  }
  .topnav{
    background-color:#10182a;
    border-bottom: 0;
  }
}

header[class='404']{
  display: none;
}


.back_button{
  height: 40px;
  width: 152px;
  font-family: "Roboto", Sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 13px;
  letter-spacing: 0px;
  border:1px #e04ef8 solid;
  color:#fff;
  background-color:#10182a;
  display: table;
  margin:0 auto;
  border-radius: 23px;
  line-height: 38px;
}
</style>




// WEBPACK FOOTER //
// 404.vue?d448762c